"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParams = getUrlParams;
exports.getHashParams = getHashParams;
exports.setUrlParams = setUrlParams;
exports.urlParams = void 0;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.search");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var urlHref = window.location.href;
var urlSearch = window.location.search;
var urlHash = window.location.hash; // 获得当前URL参数

function getUrlParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : urlSearch;
  var tmpArr = [];
  var params = {};
  var urlArr = url.split('?');

  if (urlArr.length > 1) {
    tmpArr = urlArr[1].split('#')[0].split('&');
  }

  if (tmpArr.length > 0 && tmpArr[0] !== '') {
    tmpArr.forEach(function (item) {
      var tmp = item.split('=');
      params[tmp[0]] = tmp[1];
    });
  }

  return params;
}

var urlParams = getUrlParams(); // 获得当前URL的hash参数

exports.urlParams = urlParams;

function getHashParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : urlHash;
  var tmp = '';
  var urlArr = url.split('#');

  if (urlArr.length > 1) {
    tmp = urlArr[1];
  }

  return tmp;
} // 对传入的URL设置参数


function setUrlParams() {
  var _url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : urlHref;

  var _params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _hashParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var url = _url;
  var paramsArr = [];
  var currentUrlParams = getUrlParams(url);
  var currentHashParams = getHashParams(url);

  var params = _objectSpread({}, currentUrlParams, _params);

  var hashParams = _hashParams || currentHashParams;
  Object.keys(params).forEach(function (key) {
    var str = key;

    if (params[key] != null) {
      str = "".concat(key, "=").concat(params[key]);
    }

    paramsArr.push(str);
  });
  url = "".concat(url.split('#')[0].split('?')[0]);

  if (paramsArr.length > 0) {
    url += "?".concat(paramsArr.join('&'));
  }

  if (hashParams) {
    url += "#".concat(hashParams);
  }

  return url;
}